import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function AccordionHeader(props) {
    const { header, subHeader, infoText, containerStyle } = props;
    return (_jsxs("div", { className: "accordion-header", style: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            ...containerStyle,
        }, children: [_jsxs("div", { children: [_jsx("div", { style: { fontSize: "16px", fontWeight: "500" }, children: header }), _jsx("div", { style: { fontSize: "14px", fontWeight: "300" }, children: subHeader })] }), _jsx("div", { style: { flexDirection: "row" }, children: _jsx("span", { style: { fontWeight: "300", fontSize: "14px", marginRight: "30px" }, children: infoText }) })] }));
}
export default AccordionHeader;
